import React from 'react';
import './ProjectsPage.css';
import { Link } from 'react-router-dom'; // Import the Link component
import useScrollToTop from './useScrollToTop';
import ReusableLanding from './ReusableLanding';
import image1 from '../img/exterior.jpg';
import ProjectGallery from './ProjectGallery';
import image2 from '../img/interior.jpg';
import image3 from '../img/dream_home.jpg';
import kitchenimg5 from '../img/kitchen_img_5.jpeg';
import kitchenimg6 from '../img/kitchen_img_6.jpeg';
import kitchenimg8 from '../img/kitchen_img_8.jpg';
import hallimg from '../img/hall_img_1.jpg';
import livingroomimg1 from '../img/living_room_img_1.jpg';
import livingroomimg2 from '../img/living_room_img_2.jpg';
import livingroomimg3 from '../img/living_room_img_3.jpg';
import bedroomimg1 from '../img/room_img_1.jpg';
import bedroomimg2 from '../img/room_img_2.jpg';
import bedroomimg3 from '../img/room_img_3.jpg';
import GetQuoteForm from './GetQuoteForm.js';
import Testimonials from './Testimonials.js';
import WhyChooseUs from './WhyChooseUs.js';
import Button from './Button.js';

const ProjectsPage = () => {
  const projectImages = [kitchenimg5,kitchenimg6,kitchenimg8,hallimg,
    livingroomimg1,livingroomimg2,livingroomimg3,bedroomimg1,bedroomimg2,bedroomimg3,];
  useScrollToTop();
  const projects = [
    {
      id: 1,
      name: "Modern Family Home",
      image: image1,
      description: "A contemporary home designed for modern family living.",
      path: "/modern-home", // Add a path for the link
    },
    {
      id: 2,
      name: "Commercial Office Building",
      image: image2,
      description: "A state-of-the-art office space designed for productivity.",
      path: "/commercial-office", // Add a path for the link
    },
    {
      id: 3,
      name: "Renovated Historical House",
      image: image3,
      description: "A beautifully restored historical house blending old-world charm with modern amenities.",
      path: "/historical-house", // Add a path for the link
    },
    {
      id: 4,
      name: "Luxury Apartment Complex",
      image: image1,
      description: "High-end apartments offering luxurious living spaces and amenities.",
      path: "/luxury-apartments", // Add a path for the link
    },
  ];

  return (
    <>
      <ReusableLanding
        imageUrl={image2}
        title="Our Design Portfolio: See Your Dream Home Come to Life"
        description="Explore a diverse range of customized house designs we've created, showcasing our expertise and commitment to personalized homes."
      />
      <div className="projects-page">
        <section className="projects-overview">
          <h2>Explore Our Featured Projects</h2>
          <p className="projects-intro-text">
            Discover the diverse range of architectural projects we've passionately brought to life. From modern family homes to innovative commercial spaces, each project reflects our commitment to design excellence and client satisfaction. Click on a project to learn more.
          </p>
          <div className="projects-grid">
            {projects.map((project) => (
              <div className="project-card" key={project.id}>
                <img src={project.image} alt={project.name} className="project-card-image" />
                <div className="project-card-info">
                  <h3>{project.name}</h3>
                  <p>{project.description}</p>
                  <p>
                    <Link to={project.path} className="project-link-wrapper">
                      <Button className="project-link-button">Learn More</Button>
                    </Link>
                  </p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <ProjectGallery images={projectImages} />


        <section className="get-quote-section">
          <h2>Ready to Discuss Your Project?</h2>
          <p className="quote-intro-text">
            Tell us about your vision. Fill out our simple form to get a personalized quote for your architectural needs.
          </p>
          <GetQuoteForm />
        </section>

        <section className="testimonials-section">
          <Testimonials />
        </section>

        <section className="why-choose-us-section">
          <WhyChooseUs />
        </section>
      </div>
    </>
  );
};

export default ProjectsPage;